import React from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { isMobile } from 'react-device-detect';
import styles from "./pdf-styles";
import "./pdf-report.css";
import Spinner from '../spinner/Spinner';
import PDF from "./Pdf";


const PdfReport = ({ finalResults }) => {

  if (finalResults) {

      finalResults.bars = finalResults.bars.filter(bar => bar.score);
    if (isMobile) {
      return (
        <div className="mobile-download-link">

          <h3 className="mobile-download-text">Ihr Ergebnisbericht ist bereit zum Download…</h3>

          <PDFDownloadLink document={<PDF result={finalResults} />} fileName="culture-fit-Report.pdf">
            {({ blob, url, loading, error }) =>
              loading ? "..." : 'Open Now'
            }
          </PDFDownloadLink>
        </div>
      )
    }

    return (
      <PDFViewer style={styles.document}>
        <PDF result={finalResults} />
      </PDFViewer>

    )
  } else {
    return <Spinner />
  }

};

export default PdfReport;